<template>
    <div class="">
        <quill-editor
            ref="myQuillEditor"
            v-model="notesData"
            :options="editorOption"
        />

        <div class="text-right mt-3">
            <button @click="update" class="btn btn-primary">{{ __('diary.Update') }}</button>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    props: ['notes', 'date', 'endpoint'],
    data() {
        return {
            notesData: this.notes,
            editorOption: {}
        }
    },
    methods: {
        update() {
            axios.put(this.endpoint, {
                notes: this.notesData,
                day: this.date
            }).then((result) => {
                if (result.redirect) {
                    window.location = result.redirect;
                }
            }).catch(() => {

            })
        }
    }
}
</script>

<style scoped>

</style>
